import React, { useCallback, memo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { RootState } from 'store/ducks';

import Table from "components/Table";
import { ordersItemsModel, ordersItemsModelBilled, ordersItemsModelBilledSupplier, ordersItemsModelExpressa, ordersItemsModelMobile } from "components/Table/Orders/models";
import { pedidosAction } from 'components/ApplicationInsights/eventNames';

import { isMobileDevice } from 'utils/ScreenUtils';

import { IOrderItemTableProps } from './interface';
import { ITableModel } from 'components/Table/interface';
import { EnterpriseCodeEnum } from 'models/Customer';
import { EnumUserType } from 'models/User';
import { useOrderItemTableContext } from 'contexts/OrderItemTable';

const OrderItemTable: React.FC<IOrderItemTableProps> = (props) => {
  const {
    id,
    enterpriseCode,
    enterpriseBlockedDownload,
    ordersItem,
    onReload
  } = props;

  const location = useLocation();

  const user = useSelector((state: RootState) => state.user);

  const { pageSize, currentPageItem, uploadCurrentPageItem, tableItemOrderBy, uploadTableItemOrderBy } = useOrderItemTableContext();

  const isMobile = isMobileDevice();
  const model = getModelForItemGrid();

  const getOrderAction = useCallback(() => {
    if (location.pathname === '/pedidos') {
      return pedidosAction.VISUALIZARPEDIDO;
    }

    return pedidosAction.DASHBOARD_VISUALIZARPEDIDO;
  }, []);

  const getModel = (enterpriseCodeParam?: number) => {
    if (isMobile) {
      return model || [];
    }

    if (enterpriseBlockedDownload.length > 0) {
      const modelItems = model && hideReportTechnicalSheet(model);
      const modelItemsExpressa = hideReportTechnicalSheet(ordersItemsModelExpressa);
      const modelItemsOrders = hideReportTechnicalSheet(ordersItemsModel);

      return enterpriseBlockedDownload.includes(enterpriseCodeParam || 0) ? modelItemsExpressa : modelItems || modelItemsOrders;
    } else {
      return [];
    }
  };

  const hideReportTechnicalSheet = (model: ITableModel[]) => {
    if (enterpriseCode === EnterpriseCodeEnum.ENTERPRISE_PFS) {
      return model?.filter((item: ITableModel) => item.label !== "Ficha técnica");
    }

    return model;
  };

  function getModelForItemGrid() {
    if (isMobile) {
      return ordersItemsModelMobile;
    }

    return user?.userType === EnumUserType.SUPPLIER ? ordersItemsModelBilledSupplier : ordersItemsModelBilled;
  }

  return (
    <Table
      trackingKey={getOrderAction()}
      error={ordersItem?.error}
      onReload={onReload}
      setTableOrder={uploadTableItemOrderBy}
      tableOrder={tableItemOrderBy}
      onPageChange={uploadCurrentPageItem}
      currentPage={currentPageItem}
      data={ordersItem?.data}
      pageSize={pageSize}
      totalPages={ordersItem?.totalPages}
      model={getModel(enterpriseCode)}
      completeBlankSpaces={false}
      rowHeight={40}
      customProps={{ orderId: id }}
      className="mb-1"
    />
  );
};

export default memo(OrderItemTable);